app.bind('default', function (context) {
    const $header = $('[js-header]', context);
    const $headerBox = $('[js-header-box]', context);
    const $headerFallback = $('[js-header-fallback]', context);
    const $window = $(window);
    $headerFallback.height($headerBox.outerHeight());
    $window.on('load resize', () => {
        $headerFallback.height($headerBox.outerHeight())
    });
    $window.on('load scroll', () => {
        if ($window.scrollTop() > 0) {
            $header.addClass('is-sticky')
        } else {
            $header.removeClass('is-sticky')
        }
    })
});
